import {
  CHANGE_STATUS_ORDER,
  GER_ERP_CODE,
  GET_ONE_ORDER,
  GET_SELLER_DASHBOARD_OVERVIEW,
  GET_SELLER_ORDERS,
  GET_SELLER_ORDERS_AS_CSV,
  GET_SELLER_ORDER_ANALYTICS,
  GET_SELLER_ORDER_STATISTICS,
  GET_SELLER_OVERVIEW_ORDERS,
  GET_SELLER_SALES_STATISTICS,
  GET_SELLER_TOTAL_PROFITS_STATISTICS,
  UPDATE_ERP_CODE
} from '../config/endpoints';
import api from '../config/setAuthHeader';

export const getSellerOrders = async ({ queryKey }: any) => {
  const [_, payload] = queryKey;
  const { page, size } = payload;
  const { data } = await api.get(`${GET_SELLER_ORDERS}?page=${page}&pageSize=${size}`);
  return data;
};

export const getSellerOrdersAnalytics = async () => {
  const { data } = await api.get(`${GET_SELLER_ORDER_ANALYTICS}`);
  return data;
};

export const getSellerDashboardOverview = async () => {
  const { data } = await api.get(`${GET_SELLER_DASHBOARD_OVERVIEW}`);
  return data;
};

export const getSellerOrder = async ({ queryKey }: any) => {
  const [_, payload] = queryKey;
  const { id } = payload;
  const { data } = await api.get(`${GET_ONE_ORDER}/${id}`);
  return data;
};

export const changeOrderStatus = async ({ orderId, status }: { orderId: string; status: string }) => {
  const { data } = await api.patch(`${CHANGE_STATUS_ORDER}/${orderId}/${status}`, { orderId, status });
  return data;
};
export const getSellerOverviewOrders = async ({ queryKey }: any) => {
  const [_, payload] = queryKey;
  const { orderType, page, size } = payload;
  const { data } = await api.get(`${GET_SELLER_OVERVIEW_ORDERS}${orderType}?page=${page}&size=${size}&sort=id,desc`);
  return data;
};

export const sellerOrdersStatistics = async ({ queryKey }: any) => {
  const [_, payload] = queryKey;
  const { exportDate } = payload;
  const { data } = await api.get(`${GET_SELLER_ORDER_STATISTICS}?dateTime=${exportDate}`);
  return data;
};

export const sellerSalesStatistics = async ({ queryKey }: any) => {
  const [_, payload] = queryKey;
  const { exportDate } = payload;
  const { data } = await api.get(`${GET_SELLER_SALES_STATISTICS}?dateTime=${exportDate}`);
  return data;
};

export const sellerTotalProfitsStatistics = async ({ queryKey }: any) => {
  const [_, payload] = queryKey;
  const { exportDate } = payload;
  const { data } = await api.get(`${GET_SELLER_TOTAL_PROFITS_STATISTICS}?dateTime=${exportDate}`);
  return data;
};

export const getSellerOrdersAsCsv = async () => {
  const data = await api.get(`${GET_SELLER_ORDERS_AS_CSV}`);
  return data;
};

export const updateErpSellercode = async (code: string) => {
  const { data } = await api.post(
    `${UPDATE_ERP_CODE}`,
    { code },
    {
      headers: {
        'Content-Type': 'application/json'
      }
    }
  );
  return data;
};

export const getErpSellerCode = async () => {
  const { data } = await api.get(`${GER_ERP_CODE}`);
  return data;
};
